import React from "react";
import DataTable from "react-data-table-component";
import Loader from "./loader";
export function RescueRnTable({
  data,
  loading,
  columns,
  totalRows,
  handleSort,
  onChangePage,
  handlePerRowsChange,
  perPage,
  loadingTableText = "Loading data...",
}) {
  const customStyles = {
    table: {
      style: {
        flex: 1, // makes table stretch inside flex box
        minHeight: "600px",
      },
    },
    header: {
      style: {
        backgroundColor: "var(--brand-light-blue)",
        color: "var(--brand-navy)",
        fontWeight: "bold",
        fontSize: "16px",
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        backgroundColor: "var(--brand-light-blue)",
        borderBottom: "2px solid var(--brand-silver)",
      },
    },
    headCells: {
      style: {
        color: "var(--brand-navy)",
        fontWeight: "bold",
        fontSize: "14px",
        paddingLeft: "16px",
        paddingRight: "16px",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "12px",
        paddingBottom: "12px",
      },
    },
    rows: {
      style: {
        fontSize: "14px",
        "&:nth-of-type(even)": {
          backgroundColor: "rgba(185, 212, 255, 0.2)",
        },
        "&:hover": {
          backgroundColor: "rgba(185, 212, 255, 0.5)",
          cursor: "pointer",
        },
      },
    },
  };

  return (
    <div className="table-container">
      <DataTable
        columns={columns}
        data={data}
        paginationTotalRows={totalRows}
        pagination
        paginationPerPage={10}
        perPage={perPage}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        paginationServer
        onChangePage={(page) => onChangePage(page)}
        onChangeRowsPerPage={(newPerPage) => handlePerRowsChange(newPerPage)}
        progressPending={loading}
        progressComponent={<Loader text={loadingTableText} />}
        customStyles={customStyles}
        highlightOnHover
        striped
        responsive
        sortServer // tells the table you're controlling sorting
        onSort={handleSort}
        noDataComponent={
          <div className="text-center py-4 d-flex flex-column align-items-center justify-content-center">
            <div style={{ width: 600, marginBottom: 16 }}>
              <img
                src="https://res.cloudinary.com/dhhzpdckr/image/upload/v1759174581/no-data_qfonlw.gif"
                alt="No data"
                style={{ width: "100%", height: "auto", objectFit: "contain" }}
              />
            </div>
          </div>
        }
      />
    </div>
  );
}
